import { useSyncExternalStore } from "react";

/**
 * "Open the chat at this message": the Awaiting page, a card's question and the
 * agent list's pill all hand over a message id, and the chat scrolls to it and
 * highlights it — loading earlier history until it is there, since a question can
 * sit above hours of transcript and a compaction. Kept out of the URL: it is a
 * one-off instruction to the chat about to open, not a place to come back to.
 */
let pending: { agentId: string; messageId: string; at: number } | null = null;
const listeners = new Set<() => void>();

export function focusAgentMessage(agentId: string, messageId: string): void {
  pending = { agentId, messageId, at: Date.now() };
  for (const listener of listeners) listener();
}

/** Taken once by the chat that shows it. */
export function takeAgentFocus(agentId: string): string | null {
  if (!pending || pending.agentId !== agentId) return null;
  const { messageId } = pending;
  pending = null;
  for (const listener of listeners) listener();
  return messageId;
}

/** Re-renders when a focus request arrives, so an already open chat jumps too. */
export function useAgentFocusRequest(agentId: string): string | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => (pending?.agentId === agentId ? pending.messageId : null),
  );
}
